/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import lodash, { LoDashStatic } from 'lodash';

const _ = lodash as LoDashStatic;
export default _;
